import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { reduxForm } from 'redux-form';

import { compose } from 'redux';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import { validatePopup as validate } from './validations';

import {
    AddressPopupContainer,
    ButtonGroup,
    FormGroup as DefaultFormGroup,
    GroupLabel,
    MultipleGroup,
    Title,
    OnSubmitValidator
} from '../../containers/DefaultStyles/FormDetails';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import submissionErrorHandler from '../../utils/submissionErrorHandler';

const FormGroup = styled(DefaultFormGroup)`
    margin-bottom: 0;
`;

const Error = styled.span`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-align: right;
    color: #ff245e;
    text-transform: uppercase;
    float: right;
    margin-top: 8px;
`;

class AddressForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
    }

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    checkForBlurError(name) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <AddressPopupContainer onSubmit={this.props.handleSubmit} autocomplete="on">
                <Title>
                    Voter Registration
                    {this.props.isErrorOnSubmit && (
                        <Error>An error occured. Please try again</Error>
                    )}
                </Title>
                <FormGroup>
                    <Field
                        name="postalCode"
                        onBlur={() => this.checkForBlurError('postalCode')}
                        submissionError={this.state.errors.includes('postalCode')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Postal Code"
                        placeholder="Postal Code"
                        autocomplete="on"
                        maxLength={5}
                        value={this.props.postalCode}
                        onChange={this.props.onPostalCodeChange}
                    />
                </FormGroup>
                <GroupLabel>Date of Birth</GroupLabel>
                <MultipleGroup>
                    <Field
                        name="month"
                        onBlur={() => this.checkForBlurError('month')}
                        submissionError={this.state.errors.includes('month')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.month}
                        defaultOption={'Month'}
                        label="Month"
                        type="text"
                    />
                    <Field
                        name="day"
                        onBlur={() => this.checkForBlurError('day')}
                        submissionError={this.state.errors.includes('day')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.day}
                        defaultOption={'Day'}
                        label="Day"
                        type="text"
                    />
                    <Field
                        name="year"
                        onBlur={() => this.checkForBlurError('year')}
                        submissionError={this.state.errors.includes('year')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.year}
                        defaultOption={'Year'}
                        label="Year"
                        type="text"
                    />
                </MultipleGroup>
                <ButtonGroup isAddressSubmitting={this.props.isAddressSubmitting}>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <OnSubmitValidator
                            onClick={e => {
                                e.preventDefault();
                                const errors = submissionErrorHandler(
                                    this.props.currentFormValues,
                                    validate
                                );
                                if (errors.length === 0 && !this.props.invalid) {
                                    this.props.handleSubmit();
                                } else {
                                    this.setSubmitErrors(errors);
                                }
                            }}
                        >
                            <Button
                                primary={true}
                                label={'Submit'}
                                type="submit"
                                className="submitButton"
                                disabled={this.props.invalid}
                            />
                        </OnSubmitValidator>
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </AddressPopupContainer>
        );
    }
}

AddressForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    isAddressSubmitting: PropTypes.bool,
    month: PropTypes.array,
    year: PropTypes.array,
    day: PropTypes.array,
    postalCode: PropTypes.string,
    onPostalCodeChange: PropTypes.func,
    isErrorOnSubmit: PropTypes.bool,
    currentFormValues: PropTypes.object
};

export default compose(
    connect(state => ({
        initialValues: {
            postalCode:
                state.cachedFormData.postalCode ||
                (state.localRep.localRepData.address || {}).zipCode ||
                (state.widget.endUserLocation || {}).postalCode ||
                '',
            month: state.cachedFormData.month || '',
            day: state.cachedFormData.day || '',
            year: state.cachedFormData.year || ''
        },
        currentFormValues: (state.form['addressForm'] || {}).values
    })),
    reduxForm({
        form: 'addressForm',
        destroyOnUnmount: false,
        validate
    })
)(AddressForm);
